import { useApi } from '@backstage/core-plugin-api';
import { useCallback, useState } from 'react';
import { packagesApiRef } from './packagesApi';

export const usePackagesApi = () => {
  const packagesApi = useApi(packagesApiRef);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refreshPackages = useCallback(async (packageName?: string) => {
    setIsLoading(true);
    setError(null);
    
    try {
      const result = await packagesApi.refreshPackages(packageName);
      return result;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An error occurred';
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, [packagesApi]);

  return {
    refreshPackages,
    isLoading,
    error,
  };
};